export default "__VITE_ASSET__ByXnUydA__"